import React from 'react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
export function Hero() {
  return <header className="bg-navy px-3 pb-4 pt-3 text-center sm:px-6 sm:pb-5 sm:pt-4" data-id="element-76" data-mp="eiv62y7sfcld">
      <h1 className="text-[1.3rem] font-extrabold uppercase leading-[1.08] text-white sm:text-4xl" data-id="element-77" data-mp="9k0ep7vr8fpn">
        The Complete Visual Study System for{' '}
        <span className="text-electric" data-id="element-78" data-mp="4jm5hmif2zq1">Histology &amp; Pathology Students</span>
      </h1>
      <p className="mx-auto mt-1.5 inline-block rounded bg-magenta px-2 py-0.5 font-heading text-xs font-extrabold uppercase leading-tight tracking-wide text-white sm:text-base" data-id="element-79" data-mp="128phrcgdev41">
        Stop memorizing slides. Start recognizing what you see.
      </p>
      <p className="mx-auto mt-1.5 max-w-xl text-[0.8rem] leading-snug text-white/90 sm:text-base" data-id="element-80" data-mp="ncq4lneem4s1">
        Everything you need to recognize tissues, identify key structures,
        compare microscopic patterns, and understand normal vs abnormal—in one
        complete visual study system.
      </p>
      <p className="mx-auto mt-1 max-w-xl text-[0.8rem] leading-snug text-white/80 sm:text-base" data-id="element-81" data-mp="3j89618jhw3nf">
        Spend less time jumping between scattered resources and build a clearer
        way to see, compare, differentiate, and review histology and pathology.
      </p>

      <BoxImage className="mx-auto mt-2 max-w-[280px] sm:max-w-[360px]" data-id="element-82" data-mp="3e9fsjg47kcn9" />

      <div className="mx-auto mt-2 max-w-md" data-id="element-83" data-mp="3e7l8e40rgok8">
        <CTAButton label="🚀 YES! I WANT MY VISUAL ATLAS NOW" data-id="element-84" data-mp="30hhohjpct6xy" />
        <p className="mt-2 text-[0.7rem] font-bold uppercase tracking-wide text-white/85 sm:text-xs" data-id="element-85" data-mp="30g6lhm3qg37w">
          🛡️ 7-Day Money-Back Guarantee — <span className="text-blush" data-id="element-86" data-mp="2qkd9q4xu8dr6">Zero Risk</span>
        </p>
      </div>
    </header>;
}